export const WOW_MODAL = {
  vipPaymentModuleText:
    'Congratulations! You are one step away from making massive savings!',
};
